export default __webpack_public_path__ + "static/media/detritus2-new.ec65bb66.jpg";